/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OrganisationPreferenceDto } from "./OrganisationPreferenceDto";
import {
    OrganisationPreferenceDtoFromJSON,
    OrganisationPreferenceDtoFromJSONTyped,
    OrganisationPreferenceDtoToJSON,
} from "./OrganisationPreferenceDto";
import type { OrganisationPreferenceSchemaDto } from "./OrganisationPreferenceSchemaDto";
import {
    OrganisationPreferenceSchemaDtoFromJSON,
    OrganisationPreferenceSchemaDtoFromJSONTyped,
    OrganisationPreferenceSchemaDtoToJSON,
} from "./OrganisationPreferenceSchemaDto";

/**
 *
 * @export
 * @interface OrganisationPreferenceResponseItem
 */
export interface OrganisationPreferenceResponseItem {
    /**
     *
     * @type {OrganisationPreferenceSchemaDto}
     * @memberof OrganisationPreferenceResponseItem
     */
    schema?: OrganisationPreferenceSchemaDto;
    /**
     *
     * @type {OrganisationPreferenceDto}
     * @memberof OrganisationPreferenceResponseItem
     */
    preferenceValue?: OrganisationPreferenceDto;
}

/**
 * Check if a given object implements the OrganisationPreferenceResponseItem interface.
 */
export function instanceOfOrganisationPreferenceResponseItem(
    value: object,
): value is OrganisationPreferenceResponseItem {
    return true;
}

export function OrganisationPreferenceResponseItemFromJSON(
    json: any,
): OrganisationPreferenceResponseItem {
    return OrganisationPreferenceResponseItemFromJSONTyped(json, false);
}

export function OrganisationPreferenceResponseItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrganisationPreferenceResponseItem {
    if (json == null) {
        return json;
    }
    return {
        schema:
            json["schema"] == null
                ? undefined
                : OrganisationPreferenceSchemaDtoFromJSON(json["schema"]),
        preferenceValue:
            json["preferenceValue"] == null
                ? undefined
                : OrganisationPreferenceDtoFromJSON(json["preferenceValue"]),
    };
}

export function OrganisationPreferenceResponseItemToJSON(
    value?: OrganisationPreferenceResponseItem | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        schema: OrganisationPreferenceSchemaDtoToJSON(value["schema"]),
        preferenceValue: OrganisationPreferenceDtoToJSON(
            value["preferenceValue"],
        ),
    };
}
